import { useState } from 'react';
import useMount from 'ggApp/shared/hooks/useMount';

import { contentTypes } from 'ggApp/modules/contentful/models/contentTypes';
import { mapCfEntityToUspCardsWidget } from 'ggApp/modules/contentful/models/uspCardsWidget';
import { entryService } from 'ggApp/modules/contentful';

interface UspCardContent {
    title?: string;
    steps?: { description: string; icon: { url: string }; name: string; title: string }[];
}
const useUspCardsContent = (language = 'en') => {
    const [uspCardsContent, setUspCardsContent] = useState<UspCardContent | null>(null);

    useMount(() => {
        if (!uspCardsContent) {
            entryService
                .getCfEntry(contentTypes.CfUspCardsWidget, { locale: language })
                .then((result: any) => {
                    const content = mapCfEntityToUspCardsWidget(result);
                    setUspCardsContent(content);
                });
        }
    });

    return uspCardsContent;
};

export default useUspCardsContent;
